import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Registrati from '../../../Registrazione/Registrati';
import useTrascinaGiu from '../../../../utils/useTrascinaGiu';
import './FinestraAccesso.css';
import './FinestraRegistrazione.css';

/**
 * REGISTRATI: una finestra sopra la pagina, come Accedi, non una pagina nuova.
 *
 * Chi clicca Registrati stava guardando qualcosa: la finestra lascia tutto
 * dov'e' e si chiude quando il conto e' aperto (o con la X). Il modulo e' lo
 * stesso di sempre (Registrazione/Registrati, in modalita' `nelFoglio`: senza
 * titolo, che sta qui), con «Registrati con Telegram» e il ritorno automatico.
 *
 * `ricerca` e' la query da cui si e' arrivati (/register?code=… al ritorno da
 * Telegram, ?invito=…): la route /register (RegistrazioneDaLink) la mette da
 * parte, porta alla home e chiede questa finestra, che la passa al modulo.
 * Cosi' il ritorno da Telegram riapre la finestra gia' compilata.
 *
 * `telegram` ({idToken, nonce, user}) e `avviso`: chi ha premuto «Accedi con
 * Telegram» da Accedi (o da /login) senza avere un conto arriva qui con i suoi
 * dati gia' nel modulo e l'avviso «non hai ancora un conto: prosegui».
 *
 * Stessa veste di Accedi (velo, finestra, colori della skin); piu' larga, e
 * scorre dentro se il modulo e' lungo. Sul telefono sale dal basso e si chiude
 * trascinandola giu' dalla maniglia o dal titolo.
 */
function FinestraRegistrazione({ aperta, ricerca = '', telegram = null, avviso = false, userService, onChiudi, onAccedi }) {
  const { t } = useTranslation();

  const chiudi = useCallback(() => {
    if (typeof onChiudi === 'function') onChiudi();
  }, [onChiudi]);
  const [finestra, presa] = useTrascinaGiu(chiudi);

  useEffect(() => {
    if (!aperta) return undefined;
    const allaTastiera = (e) => { if (e.key === 'Escape') chiudi(); };
    document.addEventListener('keydown', allaTastiera);
    // La pagina dietro non deve scorrere mentre la finestra e' aperta.
    const eraCosi = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', allaTastiera);
      document.body.style.overflow = eraCosi;
    };
  }, [aperta, chiudi]);

  if (!aperta) return null;

  return (
      <div
          className="velo-accesso aperto"
          role="dialog"
          aria-modal="true"
          aria-labelledby="titolo-registrazione"
          onMouseDown={(e) => { if (e.target === e.currentTarget) chiudi(); }}
      >
        <div ref={finestra} className="finestra-accesso finestra-registrazione">
          <span className="maniglia-accesso" aria-hidden="true" {...presa} />

          <div className="testa-accesso" {...presa}>
            <div>
              <h3 id="titolo-registrazione">{t('Apri il tuo conto')}</h3>
            </div>
            <button type="button" className="chiudi-accesso" onClick={chiudi} aria-label={t('Chiudi')}>
              &#10005;
            </button>
          </div>

          <div className="corpo-registrazione">
            {/* Montato solo da aperta: richiudendo e riaprendo si riparte da un modulo pulito. */}
            <Registrati userService={userService} nelFoglio onAccedi={onAccedi} onChiudi={chiudi} ricerca={ricerca || ''}
                        telegramIniziale={telegram} avvisoTelegram={avviso} />
          </div>
        </div>
      </div>
  );
}

export default FinestraRegistrazione;
